import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { compose } from 'utils/react';
import { Container, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { FOOTER } from 'utils/sectionTypes';
import { connect } from 'react-redux';
import { getCompanyName } from 'store/modules/company';
import { getRoutePath, load as loadRoutes } from 'store/modules/routes';
import style from 'components/sections/SimpleFooter/SimpleFooter.scss';
import { BUILDER } from 'shared/abilities';
import { resolveAssetUrl } from '../../../../../modules/assets';
import { section } from '../decorators';
import styles from './Footer.scss';

const Footer = ({
  companyName, isBuilderView, children, termsPath, privacyPath,
}) => {
  const [image1, image2, image3] = React.Children.toArray(children);

  return (
    <div
      className={cx(
        style.root,
        {
          [style.builder]: isBuilderView,
          [style.bottom]: !isBuilderView,
        },
        'simple-footer color-tertiary-background',
        'theme',
      )}
    >
      <Container>
        <Row className={styles.row}>
          <Col xs={12} className={styles.footerLinks}>
            <span>&copy;{companyName}</span>
            {termsPath && <span><a href={termsPath} className={style.link}>Terms</a></span>}
            {privacyPath && <span><a href={privacyPath} className={style.link}>Privacy</a></span>}
            <span>All sizes are approximate</span>
            <span>Some restrictions may apply</span>
            <a href="/admin" rel="nofollow" className={style.linkbold}>Admin</a>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={7} className={styles.logo}>
            <a target="_blank" href="http://www.storable.com/products/facility-websites/" rel="noopener noreferrer">
              <span className={styles.poweredBy}>
                Powered by
              </span>
              <img
                className={styles.storableImage}
                src={resolveAssetUrl('/img/storable-logo.svg')}
                alt="Storable Websites"
                height="16"
                width="70"
                type="image/svg+xml"
                loading="lazy"
              />
            </a>
          </Col>
          <Col xs={12} md={5} className={styles.image}>
            {image1}
            {image2}
            {image3}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Footer.propTypes = {
  companyName: PropTypes.string.isRequired,
  isBuilderView: PropTypes.bool,
  children: PropTypes.node.isRequired,
  termsPath: PropTypes.string,
  privacyPath: PropTypes.string,
};

const component = compose(
  injectIntl,
  connect(
    (state, ownProps) => ({
      companyName: getCompanyName(state),
      termsPath: getRoutePath(state, 'terms', ownProps.intl.locale),
      privacyPath: getRoutePath(state, 'privacy', ownProps.intl.locale),
    }),
  ),
  section(
    { name: 'Footer: Logos', region: FOOTER, category: 'Footer' },
    {
      subsections: [
        { accepts: ['Image'] },
        { accepts: ['Image'] },
        { accepts: ['Image'] },
      ],
      defaults: [
        ['Image', { image: { file: '/img/logo3.png', alt: 'Logo 3' } }],
        ['Image', { image: { file: '/img/logo2.png', alt: 'Logo 2' } }],
        ['Image', { image: { file: '/img/logo1.png', alt: 'Logo 1' } }],
      ],
      resolve: () => [loadRoutes()],
    },
  ),
)(Footer);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
